import { __extends } from "tslib";
import { SimpleTelemetryLogger } from './SimpleTelemetryLogger';
import { createActivity } from './Activity';
import { Error } from './InternalContracts';
import { Activity } from './Contracts';
import { getBaseCv } from './CorrelationVector';
/**
 * A TelemetryLogger that includes more advanced functions than the SimpleTelemetryLogger,
 * specifically activities and errors.
 */
var TelemetryLogger = /** @class */ (function (_super) {
    __extends(TelemetryLogger, _super);
    function TelemetryLogger(parent, persistentDataFields, config) {
        var _this = _super.call(this, parent, persistentDataFields, config) || this;
        _this.baseCv = getBaseCv();
        return _this;
    }
    /**
     * Creates a new activity. The caller is responsible for setting the result and calling endNow.
     * @param telemetryEvent - The underlying telemetry event for this activity
     */
    TelemetryLogger.prototype.createActivity = function (telemetryEvent) {
        return createActivity({
            sendTelemetryEvent: this.sendTelemetryEvent.bind(this),
            telemetryEvent: telemetryEvent,
            parentCv: this.baseCv
        });
    };
    /**
     * Advanced usage: Sends an activity. The caller is responsible for setting all of the activity parameters.
     * @param activityName - The name of the activity
     * @param activity - The activity contract
     * @param dataFields - Optional additional data fields
     * @param eventFlags - Event flags
     */
    TelemetryLogger.prototype.sendActivity = function (activityName, activity, dataFields, eventFlags) {
        return this.sendTelemetryEvent({
            eventName: activityName,
            eventContract: {
                name: Activity.contractName,
                dataFields: Activity.getFields(activity)
            },
            dataFields: dataFields,
            eventFlags: eventFlags
        });
    };
    /**
     * Sends an event with the Error data contract. A convenience wrapper around sendTelemetryEvent, with
     * an Error as a data field.
     * @param error - an ErrorEvent that represents the error
     */
    TelemetryLogger.prototype.sendError = function (error) {
        var dataFields = Error.getFields(error.error);
        if (error.dataFields != null) {
            dataFields.push.apply(dataFields, error.dataFields);
        }
        return this.sendTelemetryEvent({
            eventName: error.eventName,
            dataFields: dataFields,
            eventFlags: error.eventFlags
        });
    };
    /**
     * Creates a customer content activity, which should be ended by the caller by calling endNow().
     * @param telemetryEvent - the underlying telemetry event for the activity
     * @param customerContentType - the type of the customer content
     */
    TelemetryLogger.prototype.createCustomerContentActivity = function (customerContentEvent) {
        return createActivity({
            sendTelemetryEvent: this.sendCustomerContent.bind(this),
            telemetryEvent: customerContentEvent,
            parentCv: this.baseCv
        });
    };
    return TelemetryLogger;
}(SimpleTelemetryLogger));
export { TelemetryLogger };
//# sourceMappingURL=TelemetryLogger.js.map